import type { ReactNode } from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { useI18n } from './useI18n'
import { DAYJS_LOCALE } from './messages'

/** LocalizationProvider com o locale do dayjs (@mui/x-date-pickers) seguindo o idioma. */
export function LocalizedDates({ children }: { children: ReactNode }) {
  const { lang } = useI18n()
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={DAYJS_LOCALE[lang]}>
      {children}
    </LocalizationProvider>
  )
}
